import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useCurrentMembership } from '@identity/hooks/current-membership';
import { useCurrentEntity } from '@identity/hooks/current-entity';
import { setSentryMetadata } from 'works/legacy/lib/sentry';

export function SentryMetadataInitializer() {
  const membership = useCurrentMembership({ hideError: true });
  const entity = useCurrentEntity();

  useEffect(() => {
    if (!membership?.id || !entity?.id) return;

    setSentryMetadata(
      membership.worksUser
        ? {
            id: membership.worksUser.id,
            email: membership.worksUser.email,
            firstName: membership.worksUser.firstName,
            lastName: membership.worksUser.lastName,
            roles: [membership.role],
            timeZone: membership.worksUser.timeZone,
          }
        : undefined,
      { id: entity.id, name: entity.name, type: entity.entityType },
      { id: membership.id, role: membership.role }
    );

    const globalScope = Sentry.getGlobalScope();
    globalScope.setTag('trusted.entity_id', entity.id);
    globalScope.setTag('trusted.membership_role', membership.role);
    globalScope.setTag('trusted.entity_type', entity.entityType);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally scoped to identity-changing fields; user profile data changes (name, email) do not warrant re-tagging
  }, [membership?.id, membership?.role, entity?.id, entity?.entityType]);

  return null;
}
